import React, { useState,useEffect } from 'react'
import Select from 'react-select';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import "./featurelist1.css";
import { useAlert } from "react-alert";
import CustomSelect from './CustomSelect.js';
import { DosageOptions, RouteOptions, StrengthOptions, medicinclasses } from './formOptionsFT.js';
function Addmedicine(props) {
   const [hospitals, setHospitals] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState(null);
    const [healthType, setHealthType] = useState(null);
    const [loading, setLoading] = useState(false);
  const alert = useAlert();
  let formData = new FormData();
  const [image, setImage] = useState(null);

  const [data, setData] = useState({

    medicinename: '',
    genericname: '',
    strength: '',
    composition: '',
    medicinetype: { value: '', label: '' },
    dosage_type: { value: '', label: '' },
    medicinecode: '',
    routine: { value: '', label: '' },
    description: '',
    manufacturername: '',
    strength_unit: { value: '', label: '' },
    med_interactions: "",
    med_url: null,
    manufacturer_address: "",
    

  })

  const [error, setError] = useState({
    medicinename: '',
    genericname: '',
    strength: '',
    medicinetype: '',
    dosage_type: '',
    strength_unit: '',
    medicinecode: '',
    routine: '',
    composition: ''


  });

  const [successShow, setSuccessShow] = useState(false)
  const [errorValidate, setErrorValidate] = useState(false)

  const handleTitle = (e) => {

    e.preventDefault();
    const val = e.target.value;
    const key = e.target.name;

    setError(currentstate => ({
      ...currentstate,
      [key]: ""
    }));




    setData(current => ({
      ...current, [key]: key === "medicinecode" ? val.replace(/\s+/g, '') : val
    }))
  }

 useEffect(() => {
        fetchHospitals();
    }, []);
const healthcareoptions=[
  { value: 'ModernMedicine', label: 'Modern Medicine' },
  { value: 'Unani', label: 'Unani' }
]
  const handleServiceChange = (data) => {

    setData(current => ({
      ...current, dosage_type: data
    }))
  }

  const strengthChange = (data) => {

    setData(current => ({
      ...current, strength_unit: data
    }))
  }

  const handleMedicineType = (data) => {

    setData(current => ({
      ...current, medicinetype: data
    }))
  }

  const handleUnitChange = (data) => {

    setData(current => ({
      ...current, routine: data
    }))
  }


  const validate = () => {

    let input = data;
    let errors = {};
    let isValid = true;
    setError({});


    if (!input["medicinename"] || input["medicinename"].trim() === "") {
      isValid = false;
      errors["medicinename"] = "Enter generic name of medicine";
    }
    // if (!input["genericname"] || input["genericname"] === "") {
    //   isValid = false;
    //   errors["genericname"] = "Enter generic name of medicine";
    // }
    // if (!input["strength"] || input["strength"].trim() === "") {
    //   isValid = false;
    //   errors["strength"] = "Enter strength of medicine";
    // }
    // if (!input["medicinetype"].value || input["medicinetype"].value === "") {
    //   isValid = false;
    //   errors["medicinetype"] = "Select medicine type";
    // }
    // if (!input["dosage_type"].value || input["dosage_type"].value === "") {
    //   isValid = false;
    //   errors["dosage_type"] = "Select dosage type";
    // }
    // if (!input["strength_unit"].value || input["strength_unit"].value === "") {
    //   isValid = false;
    //   errors["strength_unit"] = "Select strength unit";
    // }
    // if (!input["medicinecode"] || input["medicinecode"].trim() === "") {
    //   isValid = false;
    //   errors["medicinecode"] = "Enter Med code";
    // }
    // if (!input["routine"].value || input["routine"].value === "") {
    //   isValid = false;
    //   errors["routine"] = "Select route of medicine";
    // }
    if (
      input["med_url"] !== "" &&
      input["med_url"] !== null
    ) {
      var regex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      var pattern = new RegExp(regex);
      if (!pattern.test(input["med_url"])) {
        isValid = false;
        errors["med_url"] = "Enter a valid url.";

      }
    }
    // if (!input["composition"] || input["composition"] === "") {
    //   isValid = false;
    //   errors["composition"] = "Enter composition of medicine";
    // }
    if (!selectedHospital.value===null || selectedHospital.value.value === "") {
      isValid = false;
      errors["hospital"] = "Select clinic";
    }
    if (healthType.value===null || healthType.value === "") {
      isValid = false;
      errors["healthcaretype"] = "Select healthcare type";
    }




    setError(currentstate => ({
      ...currentstate,
      ...errors
    }));


    return isValid;
  }
  
  const fetchHospitals = async () => {
    setLoading(true);
    try {
        const tokenString = sessionStorage.getItem("usertoken");
        const v2 = tokenString.replace(/["]+/g, "");

        const response = await axios.get(`${APIURL}/api/v1/staff/hospital-approve/`, {
            headers: { Authorization: "Token " + v2 },
            params: { status: 'approved' }
        });

        if (response.data.status === 'success') {
            setHospitals(response.data.hospitals.map(hospital => ({
                value: hospital.id,
                label: `${hospital.name} - ${hospital.location}`,
                data: hospital
            })));
        }
    } catch (error) {
        console.error('Error fetching hospitals:', error);
        alert.error('Failed to load hospitals');
    } finally {
        setLoading(false);
    }
};

  const saveChanges = (e) => {

    e.preventDefault();


    if (validate()) {
      const tokenString = sessionStorage.getItem("usertoken");

      let v2 = tokenString.replace(
        /["]+/g,
        ""
      ); /* REGEX To remove double quotes from tokenstring */
const medicineData={   med_name: (data.medicinename.slice(0, 1).toUpperCase() + data.medicinename.slice(1, data.medicinename.length)).trim(),
   generic_name: data.genericname,
  strength: data.strength.trim(),
  strength_unit: data.strength_unit.value,
  med_type: data.medicinetype.value,
  dosage_form: data.dosage_type.value,
  med_code: data.medicinecode,
  route: data.routine.value,
  description: data.description.trim(),
  composition: data.composition.trim(),
  manufacturer_name: data.manufacturername !== null ? data.manufacturername.trim() : "",
  manufacturer_address: data.manufacturer_address !== null ? data.manufacturer_address.trim() : "",
  med_interactions: data.med_interactions !== null ? data.med_interactions.trim() : "",
  med_url: data.med_url !== null ? data.med_url.trim() : ""

}
Object.keys(medicineData).forEach((key) => {
  if (
    medicineData[key] === null ||
    medicineData[key] === undefined ||
    medicineData[key] === ''
  ) {
    delete medicineData[key];
  }
});
      const dataToSend = {
        "healthcare_type":healthType.value,
        "hospital_id":Number(selectedHospital.value),
        "medicines":[medicineData]}
     
      const formData = new FormData();
      if (image) {
        formData.append('image', image);
      }
      Object.keys(dataToSend).forEach(key => formData.append(key, dataToSend[key]));

      axios
        .post(`${APIURL}/api/v1/staff/medicine-search/V2/`, dataToSend, {
          headers: { Authorization: "Token " + v2 },
        })
        .then((res) => {
          if (res.data.status === "success") {
            alert.success("Successfully Saved")
            props.modalClose()

            setData({
              medicinename: '',
              genericname: '',
              composition: '',
              strength: '',
              medicinetype: { value: '', label: '' },
              dosage_type: { value: '', label: '' },
              strength_unit: { value: '', label: '' },
              medicinecode: '',
              routine: { value: '', label: '' },
              description: '',
              manufacturername: '',
              med_interactions: null,
              med_url: null

            });
          } else {
            alert.error(res.data.message)
          }
        })
        .catch((err) => {

        });
      setSuccessShow(false)
    }

    else {
      setErrorValidate(true)
    }

  }


  return (
    <>
      <div className='medicine-form-container'>
        <div className='form-section'>
          <div className='flex-display'>
          <div className='pricing-inputcontainer col-4'>
              <label className='required'>Clinic</label>
              <CustomSelect
                 value={selectedHospital}
                 onChange={(data, e) => {
                  console.log("data",data)
                  setSelectedHospital(data)
setHealthType({label:data.data.health_care_type,value:data.data.health_care_type})
                  setError(currentstate => ({
                    ...currentstate,
                    hospital: ""
                  }));
                }}
                 options={hospitals}
                 isLoading={loading}
                 isSearchable={true}
                
                 placeholder="Select hospital..."
                 name='hospital'
                 error={error.hospital}
              />
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Healthcare type</label>
              <CustomSelect
              isDisabled={true}
                 value={healthType}
                 onChange={(data, e) => {
                  setHealthType(data)
                  setError(currentstate => ({
                    ...currentstate,
                    healthcaretype: ""
                  }));
                }}
                 options={healthcareoptions}
                 isLoading={loading}
                 isSearchable={true}
                
                 placeholder="Select hospital..."
                 name='healthcaretype'
                 error={error.healthcaretype}
              />
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Generic Name</label>
              <input
                className={`${error.medicinename ? 'has-error-input' : ''}`}
                type='text'
                maxLength="300"
                name='medicinename'
                value={data.medicinename}
                onChange={handleTitle}
              />
              {error.medicinename && <div className="error-message">{error.medicinename}</div>}
            </div>
          
          </div>
          <div className='flex-display'>
         
            <div className='pricing-inputcontainer col-4'>
              <label >Strength</label>
              <input
                className={`${error.strength ? 'has-error-input' : ''}`}
                type='text'
                maxLength="50"
                name='strength'
                value={data.strength}
                onChange={handleTitle}
              />
              {error.strength && <div className="error-message">{error.strength}</div>}
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label >Strength Unit</label>
              <CustomSelect
                value={data.strength_unit}
                onChange={(data, e) => {
                  strengthChange(data, e);
                  setError(currentstate => ({
                    ...currentstate,
                    strength_unit: ""
                  }));
                }}
                options={StrengthOptions}
                name='strength_unit'
                error={error.strength_unit}
              />
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label>Manufacturer Name</label>
              <input
                type='text'
                maxLength="100"
                name='manufacturername'
                value={data.manufacturername}
                onChange={handleTitle}
              />
            </div>
          </div>
          <div className='flex-display'>
          
            <div className='pricing-inputcontainer col-4'>
              <label>Manufacturer Address</label>
              <textarea
                maxLength="400"
                name='manufacturer_address'
                value={data.manufacturer_address}
                onChange={handleTitle}
              />
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label >Composition</label>
              <textarea
                className={`${error.composition ? 'has-error-input' : ''}`}
                maxLength="400"
                name='composition'
                value={data.composition}
                onChange={handleTitle}
              />
              {error.composition && <div className="error-message">{error.composition}</div>}
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label>Description</label>
              <textarea
                maxLength="500"
                name='description'
                value={data.description}
                onChange={handleTitle}
              />
            </div>
          </div>
          <div className='flex-display'>
          <div className='pricing-inputcontainer col-3'>
              <label>Med Code</label>
              <input
                className={`${error.medicinecode ? 'has-error-input' : ''}`}
                type='text'
                maxLength="20"
                name='medicinecode'
                value={data.medicinecode}
                onChange={handleTitle}
              />
              {error.medicinecode && <div className="error-message">{error.medicinecode}</div>}
            </div>
            <div className='pricing-inputcontainer col-3'>
              <label >Medicine Type</label>
              <CustomSelect
                value={data.medicinetype}
                onChange={(data, e) => {
                  handleMedicineType(data, e);
                  setError(currentstate => ({
                    ...currentstate,
                    medicinetype: ""
                  }));
                }}
                options={medicinclasses}
                name='medicinetype'
                error={error.medicinetype}
              />
            </div>
            <div className='pricing-inputcontainer col-3'>
              <label >Dosage</label>
              <CustomSelect
                value={data.dosage_type}
                onChange={(data, e) => {
                  handleServiceChange(data, e);
                  setError(currentstate => ({
                    ...currentstate,
                    dosage_type: ""
                  }));
                }}
                options={DosageOptions}
                name='dosage_type'
                error={error.dosage_type}
              />
            </div>
            <div className='pricing-inputcontainer col-3'>
              <label >Route</label>
              <CustomSelect
                value={data.routine}
                onChange={(data, e) => {
                  handleUnitChange(data, e);
                  setError(currentstate => ({
                    ...currentstate,
                    routine: ""
                  }));
                }}
                options={RouteOptions}
                name='routine'
                error={error.routine}
              />
            </div>
          </div>
          <div className='flex-display'>
         
            <div className='pricing-inputcontainer col-4'>
              <label>Drug Interactions</label>
              <textarea
                className={`${error.med_interactions ? 'has-error-input' : ''}`}
                name='med_interactions'
                value={data.med_interactions}
                onChange={handleTitle}
              />
            </div>
            <div className='pricing-inputcontainer col-4'>
              <label>Drug Interactions URL</label>
              <textarea
                placeholder="https://www.example.com"
                className={`${error.med_url ? 'has-error-input' : ''}`}
                name='med_url'
                value={data.med_url}
                onChange={handleTitle}
              />
              {error.med_url && <div className="error-message">{error.med_url}</div>}
            </div>
          </div>
        </div>
        <div className='form-actions'>
          <button onClick={saveChanges} style={{ marginLeft: "auto" }} className='add-btn'>Save Medicine</button>
        </div>
      </div >

    </>

  )
}

export default Addmedicine